/* ============================================================
   SlushyFun — Shopify Theme JS
   Shared: particles, scroll reveal, FAQ toggle, nav scroll effect
   Does NOT include cart logic or page-specific functions.
   ============================================================ */

/* ─── SCROLL REVEAL ─── */
(function () {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
})();

/* ─── FAQ TOGGLE ─── */
window.toggleFaq = function (el) {
  const item = el.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
};

/* ─── MOBILE NAV TOGGLE ─── */
(function () {
  const hamburger = document.getElementById('navHamburger');
  const navLinks  = document.getElementById('navLinks');
  if (!hamburger || !navLinks) return;

  hamburger.addEventListener('click', () => {
    const open = navLinks.classList.toggle('mobile-open');
    hamburger.classList.toggle('is-open', open);
    hamburger.setAttribute('aria-expanded', open);
  });
  navLinks.addEventListener('click', e => {
    if (e.target.tagName === 'A' && !e.target.closest('.nav-dropdown > a')) {
      navLinks.classList.remove('mobile-open');
      hamburger.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
    }
  });
})();


/* ─── SHOP DROPDOWN (mobile tap toggle) ─── */
window.navShopClick = function (e) {
  const hamburger = document.getElementById('navHamburger');
  const isMobile = hamburger && getComputedStyle(hamburger).display !== 'none';
  if (!isMobile) return true; // desktop: let the link navigate normally
  e.preventDefault();
  const li  = e.currentTarget.closest('.nav-dropdown');
  const sub = document.getElementById('shopSub');
  const open = li.classList.toggle('mobile-open');
  sub.classList.toggle('mobile-open', open);
  return false;
};

/* ─── VIDEO AUTOPLAY ─── */
/* iOS Safari blocks play() from async callbacks (not a user gesture).
   Strategy: IntersectionObserver handles play/pause as videos scroll in/out;
   first-touch listener unlocks any in-view video that the browser blocked. */
(function () {
  const videos = [...document.querySelectorAll('video[autoplay]')];
  if (!videos.length) return;

  videos.forEach(v => { v.muted = true; });

  function tryPlay(v) {
    v.muted = true;
    if (v.readyState === 0) v.load();
    v.play().catch(() => {});
  }

  function playVisible() {
    videos.forEach(v => {
      const r = v.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0 && v.paused) tryPlay(v);
    });
  }

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) tryPlay(e.target);
      else e.target.pause();
    });
  }, { threshold: 0.1 });
  videos.forEach(v => io.observe(v));

  /* After any user touch/click, retry in-viewport paused videos.
     This is the iOS unlock — play() is always allowed after a gesture. */
  document.addEventListener('touchstart', playVisible, { once: true, passive: true });
  document.addEventListener('click', playVisible, { once: true });
})();


